<template>
  <div class="w-70 mt-1">
    <el-autocomplete
      v-if="showSearchInput"
      v-model="domainState"
      :fetch-suggestions="fetchSuggestions"
      placeholder="Search Domain"
      @select="handleSelect"
      :loading="isLoading"
      prefix-icon="el-icon-search"
    >
      <!-- Custom search icon inside the input field -->
      <template #prefix>
        <el-icon><search /></el-icon>
      </template>
    </el-autocomplete>
  </div>
</template>

<script>
import { fetchDomainData } from "../../service/emailDetails";
import { Search } from '@element-plus/icons-vue';
export default {
  components:{
    Search
  },
  props: {
    showSearchInput: {
      type: Boolean,
      default: true,
    },
    domainName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      domainState: "",
      isLoading: false, // Controls the loading state
    };
  },
  methods: {
    async fetchSuggestions(queryString, cb) {
      if (!queryString || queryString.length < 3) {
        cb([{ value: "Enter at least 3 characters" }]);
        return;
      }

      this.isLoading = true;

      setTimeout(async () => {
        try {
          let response = await fetchDomainData(queryString);
          console.log("API Response:", response);

          if (response.data?.suggestions && Array.isArray(response.data.suggestions)) {
            this.domainList = response.data.suggestions.map((domain, index) => ({
              id: `domain-${index + 1}`,
              label: domain,
              value: domain,
            }));

            cb(this.domainList.length ? this.domainList : [{ value: "No Data Available" }]);
          } else {
            cb([{ value: "No Data Available" }]);
          }
        } catch (error) {
          console.error("Fetch Error:", error);
          cb([{ value: "No Data Available" }]);
        } finally {
          this.isLoading = false;
        }
      }, 500);
    },

    handleSelect(item) {
      if (item.value !== "No Data Available") {
        this.domainState = item.value;
        this.$emit("update-domain", item.value);
      }
    },

  },
};
</script>
